<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner9.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">{{ $t("home") }}</li>
        <li>></li>
        <li>{{ $t("news") }}</li>
        <li>></li>
        <li>{{ newsDetail.title }}</li>
      </ul>
      <h3 class="tab_title" style="margin-bottom: 40px">{{ newsDetail.title }}</h3>
      <div class="editor" v-html="newsDetail.content"></div>
    </div>
  </div>
</template>
<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { getNewsDetail } from "../../api/index";
export default {
  data() {
    return {
      newsDetail: {},
      name: "新闻资讯",
      path1: "",
    };
  },
  beforeRouteUpdate(to, from, next) {
    // 当路由更新时（比如语言变化），重新获取数据
    this.fetchNewsDetail();
    next();
  },
  mounted() {
    this.fetchNewsDetail()
  },
  methods: {
    fetchNewsDetail(){
      getNewsDetail(this.$route.query.id).then((res) => {
        console.log(res);
        this.newsDetail = res.data;
        this.name = this.newsDetail.category == 3 ? "技术文章" : "新闻资讯";
      });
    },
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
    backPage(page) {
      if (page) {
        
      } else {
        if (this.name == "技术文章") {
          page = "/fwzc/tecArticles";
        } else if (this.name == "新闻资讯") {
          page = "/news";
        }
      }

      const fullPath = this.getLocalizedPath(page);
      this.$router.replace({ path: fullPath });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/news/detail.vue